import Common from "../../../Common";

const Template = class extends Common {
	read = (): CustomResponse<{templates: AClPermissionTemplate[]}> =>
		this.get('/acl/permission/template')
}

export default Template
